import { Button, Col, Input, message, Row } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { FC, useRef } from "react";

import "./uploadSalaryRange.less";
import Modal from "@components/Modal";
import { IModal } from "@types";
import { validateFile } from "@utils";
import CustomModal from "../customModel";
import customErrorMessage from "../CustomErrorMessage";

const SAMPLE_FILES_MAP: Record<string, string> = {
  "Upload Job Grades": "/samples/job-grade.csv",
  "Upload Salary Ranges": "/samples/salary-range.csv",
  "Upload Cash Allowances": "/samples/cash-allowance.csv",
  "Upload Internal Payroll Data": "/samples/internal-payroll.csv",
  "Upload Market Data": "/samples/market-data.csv",
  "Upload Short Term Incentives": "/samples/short-term-incentive.csv",
  "Upload Long Term Incentives": "/samples/long-term-incentive.csv",
};

interface IUpload extends IModal {
  onSubmit: any;
  file: { file: File | null; active: boolean };
  title: string;
  setFile: React.Dispatch<
    React.SetStateAction<{
      file: null;
      active: boolean;
    }>
  >;
}

const Upload: FC<IUpload> = ({
  isVisible,
  setIsVisible,
  onSubmit,
  file,
  setFile,
  title,
}) => {
  const inputRef = useRef<any>(null);

  const uploadFile = (event: any) => {
    var file = event?.target?.files[0];
    if (validateFile(file?.type)) {
      setFile(prev => ({ ...prev, file }));
    } else {
      customErrorMessage("Only CSV file type is supported");
    }
  };

  const resetFile = () => {
    setFile({ file: null, active: false });
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <CustomModal
      width="w-5/12"
      isVisible={isVisible}
      title={title}
      onClose={() => {
        resetFile();
        setIsVisible(false);
      }}
      footer={
        <>
          <button
            className="bg-themeGrey text-themeBlack font-medium text-lg py-2 px-14 rounded-md"
            onClick={() => {
              resetFile();
              setIsVisible(false);
            }}
          >
            Cancel
          </button>
          <button
            className={`bg-themeBlue text-white font-medium text-lg py-2 px-14 rounded-md `}
            onClick={async () => {
              try {
                await onSubmit(); // wait for parent API
              } catch (e) {
                // optional: ignore, parent already handles errors
              } finally {
                // ✅ ALWAYS RESET (success/fail)
                resetFile();
                setIsVisible(false);
              }
            }}
            disabled={!file?.file}
          >
            Upload
          </button>
        </>
      }
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col className="uploadSalaryRange__uploadField" span={24}>
            <label className="font-semibold !text-themeInputTitleColor text-lg leading-10 ">
              Upload File
            </label>

            <Input
              size="large"
              name="name"
              readOnly
              accept=".csv, application/vnd.ms-excel"
              className="w-full shadow-sm font-semibold text-sm  outline-none border border-themeInputBorder bg-white rounded-md"
              value={file?.file?.name || ""}
              placeholder="Only CSV is supported"
              addonAfter={
                <button
                  className="bg-themeBlue text-white  py-2 px-7 rounded-md"
                  type="button"
                  onClick={() => inputRef?.current?.click()}
                >
                  Upload
                </button>
              }
            />
            {/* ✅ Download Sample Button */}
            <div className="mt-2 ml-1">
              <a
                href={SAMPLE_FILES_MAP[title]}
                download
                className="text-themeBlue font-medium underline cursor-pointer"
              >
                Download Sample File
              </a>
            </div>
            <input
              id="myInput"
              type="file"
              ref={inputRef}
              hidden={true}
              onChange={uploadFile}
            />
          </Col>
        </Row>
        <Row className="mb-20">
          <Checkbox
            checked={file?.active}
            onChange={event =>
              setFile(prev => ({ ...prev, active: event.target.checked }))
            }
          >
            <span
              className={"font-semibold  text-lg text-themeInputTitleColor "}
            >
              Active
            </span>
          </Checkbox>
        </Row>
      </>
    </CustomModal>
  );
};
export default Upload;
